import React from 'react';
import cn from 'classnames';
import ReactDOM from 'react-dom';
import styles from './Modal.module.scss';
import { GreyDimmer } from './Dimmer';
import { addStyle } from './utils';

export const WhiteModal = ({
  isOpen, onCancel, children, style,
}) => {
  const Modal = (
    <GreyDimmer isVisible={isOpen} onClick={onCancel}>
      <div
        style={style}
        tabIndex={-1}
        role="button"
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={cn(styles.modal, addStyle(isOpen, styles.modalVisible))}>
        {children}
      </div>
    </GreyDimmer>
  );
  return ReactDOM.createPortal(Modal, document.body);
};

export const NavMenuModal = ({ isOpen, onCancel, children }) => {
  const Modal = (
    <GreyDimmer
      className={styles.dimmerForNavMenuModal}
      isVisible={isOpen}
      onClick={onCancel}>
      <div
        tabIndex={-1}
        role="button"
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={cn(
          styles.navMenuModal,
          addStyle(isOpen, styles.modalVisible),
        )}>
        {children}
      </div>
    </GreyDimmer>
  );
  return ReactDOM.createPortal(Modal, document.body);
};
